<app-doc-viewer title="Workspace" subtitle="Geo">
  <app-example-viewer codeFolder="geo/workspace">
    <igo-map-browser [map]="map" [view]="view" class="m-b-16">
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>

    <igo-workspace-selector
      igoWorkspaceSelector
      [store]="workspaceStore"
      [map]="map"
    />

    @if (selectedWorkspace$ | async; as workspace) {
      @if ($any(workspace).inResolutionRange$ | async) {
        <igo-entity-table-paginator
          [store]="workspace.entityStore"
          [paginatorOptions]="paginatorOptions"
          [entitySortChange$]="entitySortChange$"
          (paginatorChange)="paginatorChange($event)"
        />
      }
    }

    @if (selectedWorkspace$ | async; as workspace) {
      @if (workspace.actionStore) {
        <igo-actionbar
          [store]="workspace.actionStore"
          [horizontal]="true"
          [withToggleButton]="true"
          [withTitle]="true"
          [mode]="actionbarMode"
        />
      }
      @if (
        workspace.entityStore &&
        workspace.meta &&
        workspace.meta.tableTemplate &&
        ($any(workspace).inResolutionRange$ | async)
      ) {
        <igo-entity-table
          class="table-compact table-centered"
          [paginator]="workspacePaginator"
          [scrollBehavior]="scrollBehavior"
          [store]="workspace.entityStore"
          [template]="workspace.meta.tableTemplate"
        />
      }
      @if (($any(workspace).inResolutionRange$ | async) === false) {
        <mat-card-content>
          No data available at this scale. Please zoom in.
        </mat-card-content>
      }
      <igo-workspace-widget-outlet [workspace]="workspace" />
    }
  </app-example-viewer>
</app-doc-viewer>
